<template lang="pug">
v-card.mb-3
  v-card-title.grey.lighten-4(v-if="extra && extra.options.show_panel_title") {{extra.name}}
  v-card-text
    v-treeview(activatable item-key="slug" item-text="name" :active="active" @update:active="activate" open-all :items="items")

</template>

<script>
export default {
  props: ['extra'],
  data() {
    return {
      active: [],
    }
  },
  mounted() {
    const items = this.items
    if (!items[0]) {
      return
    }

    const path = this.$route.path.match(/\/.*\/(.*)/)
    if (path && path[1]) {
      this.active = [path[1]]
    } else {
      this.active = [items[0].slug]
    }
  },
  computed: {
    items() {
      return this.extra && JSON.parse(this.extra.content) || []
    },
  },
  methods: {
    activate(slugs) {
      const slug = slugs[0]
      if (slug && !/^\?/.test(slug)) {
        const base = this.$route.path.replace(/(\/[^/]*)\/.*/, '$1')
        const url = `${base}/${slug}`
        this.$router.push(url)
      }
    }
  }
}
</script>
